module.exports = __webpack_public_path__ + "static/media/icon-vnpt.d8fb929c.svg";